export const lengthDataHandler = (rows: any[], columns: any[]) => ({
  rowsLength: rows.length,
  columnsLength: columns.length,
});
